import { useDisplayMessage } from '../hooks/useDisplayMessage'
import type { MessageSource } from '../lib/messageSource'
import { assertNever, type DisplayMessage, type Place } from '../types/display'
import BrandPanel from './BrandPanel'
import OrderPanel from './OrderPanel'
import ChangeOverlay from './overlays/ChangeOverlay'
import ErrorOverlay from './overlays/ErrorOverlay'
import PaymentOverlay from './overlays/PaymentOverlay'

function overlayFor(message: DisplayMessage | null, currency: string) {
  if (!message) return null

  switch (message.type) {
    case 'cart_update':
      return null
    case 'scan_mobilepay_qr_code':
      return <PaymentOverlay kind="mobilepay" url={message.url} amount={message.amount} currency={currency} />
    case 'scan_receipt_qr_code':
      return <PaymentOverlay kind="receipt" url={message.url} amount={message.amount} currency={currency} />
    case 'change_given':
      return <ChangeOverlay kind="change" amount={message.change} currency={message.currency ?? currency} />
    case 'cashback_given':
      return <ChangeOverlay kind="cashback" amount={message.cashback} currency={currency} />
    case 'payment_error':
      return <ErrorOverlay message={message.message} />
    default:
      return assertNever(message)
  }
}

export default function Display({
  placeId,
  place,
  source,
}: {
  placeId: string
  place: Place | null
  source: MessageSource
}) {
  const { message, cart } = useDisplayMessage(source)
  const currency = cart?.currency ?? place?.currency ?? 'DKK'

  return (
    <div className="flex h-screen w-screen">
      <BrandPanel placeId={placeId} place={place} />
      <OrderPanel cart={cart} currency={currency}>
        {overlayFor(message, currency)}
      </OrderPanel>
    </div>
  )
}
